const desktop = theme => {
  return {
    playerDisplayName: {
      color: 'white',
      fontSize: 14,
    },
  };
};
const mobile = theme => {
  return {
    antdTable: {
      '& .ant-table': {
        background: '#202633',
      },
      '& .ant-table-thead>tr>th': {
        border: 'none',
        background: 'transparent',
        color: '#807e7e',
      },
      '& .ant-table-tbody>tr>td': {
        border: 'none',
      },
      '&.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover':
        {
          background: 'inherit',
        },
      '& .darkRow': {
        backgroundColor: '#2B313D',
        borderRadius: 10,
        '& > td:first-child': {
          borderTopLeftRadius: 10,
          borderBottomLeftRadius: 10,
        },
        '& > td:last-child': {
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
        },
      },
      '& .darkerRow': {
        backgroundColor: '#202633i',
        // animation: '$waterfall 0.5s ease-in-out',
      },
      // ! fixed ant table hover white color
      '& .ant-table-tbody > tr.ant-table-row:hover > td': {
        background: 'none',
      },
    },
    colText: {
      color: 'white',
    },
    playerDisplayName: {
      color: 'white',
      // fontSize: 9,
    },
    userIcon: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      marginRight: 5,
    },
    '@keyframes waterfall': {
      '0%': {
        opacity: 0,
        transform: 'translateY(-30px)',
      },

      '100%': {
        opacity: 1,
        transform: 'translateY(0px)',
      },

      waterfall: {
        animationName: 'waterfall',
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'both',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
